import { render, staticRenderFns } from "./BtnVersionEstable.vue?vue&type=template&id=ac286918&"
import script from "./BtnVersionEstable.vue?vue&type=script&lang=js&"
export * from "./BtnVersionEstable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports